import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import './ATTwoColumnLayout.css'
import Authorize from '../../common/auth/Authorize'
import { getWidgetMapping } from '../../../utils/authUtil/AuthUtil'
import { WIDGET_TYPE } from '../../common/auth/AuthorizeConstant'
interface AtTwoColumnLayoutProps {
  listPanel: React.ReactNode
  detailsPanel: React.ReactNode
  widgetName: string
}

const AtTwoColumnLayout: React.FC<AtTwoColumnLayoutProps> = ({
  listPanel,
  detailsPanel,
  widgetName,
}) => {
  return (
    <Container fluid className="h-100">
      <Authorize
        widgetId={getWidgetMapping(widgetName)}
        widgetType={WIDGET_TYPE.VIEW}
      >
        <Row className="h-100">
          <Col md={3} className="list-panel">
            {listPanel}
          </Col>
          <Col md={9} className="detail-panel overflow-auto h-100">
            {detailsPanel}
          </Col>
        </Row>
      </Authorize>
    </Container>
  )
}
export default AtTwoColumnLayout
